import { Flex, Text } from '@skin-seoul/design-system';

export const ReviewEmpty = () => {
  return (
    <Flex direction="column" align="flex-start" w="full" py="24px" gap="8px" borderBottom="1px solid #e9eaeb">
      <Text>Be the first to write a review!</Text>
      <Text color="neutral.700" textStyle="paragraph.xsmall" fontWeight="normal">
        Tell others what you think!
      </Text>
      <Text color="neutral.700" textStyle="paragraph.xsmall" fontWeight="normal">
        Tell others what you think!
      </Text>
    </Flex>
  );
};

export default ReviewEmpty;
